import Vue from "vue";
import VueDayjs from "vue-dayjs-plugin";

Vue.use(VueDayjs);
